import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, Mail, Lock, Eye, Loader2 } from "lucide-react";
import { useAuth } from "../AuthContext";
import { toast } from "sonner";

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(name, email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Cuenta creada");
      navigate("/app");
    } else {
      toast.error(r.error || "Error al registrar");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0 radial-bg pointer-events-none" />
      <div className="absolute inset-0 scan-grid opacity-25 pointer-events-none" />

      <div className="relative flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <Eye size={22} className="text-[#DEFF9A]" />
            <span className="font-display text-lg tracking-tight">ScanEye</span>
          </Link>

          <h1 className="font-display text-4xl tracking-tighter mb-2">Crea tu cuenta</h1>
          <p className="text-[#8A8F98] text-sm mb-8">
            3 análisis gratis · Sin tarjeta de crédito.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <User size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
              <input
                data-testid="register-name-input"
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Tu nombre"
                className="se-input w-full bg-[#0A0A0A] border border-[#1F2428] rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none transition-all"
              />
            </div>
            <div className="relative">
              <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
              <input
                data-testid="register-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@empresa.com"
                className="se-input w-full bg-[#0A0A0A] border border-[#1F2428] rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none transition-all"
              />
            </div>
            <div className="relative">
              <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
              <input
                data-testid="register-password-input"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                className="se-input w-full bg-[#0A0A0A] border border-[#1F2428] rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none transition-all"
              />
            </div>
            <button
              data-testid="register-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-[#DEFF9A] hover:bg-[#C8FF6E] text-black font-bold rounded-lg py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 glow-acid"
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              {loading ? "Creando cuenta..." : "Crear cuenta"}
            </button>
          </form>

          <p className="text-center text-sm text-[#8A8F98] mt-6">
            ¿Ya tienes cuenta?{" "}
            <Link to="/login" data-testid="register-to-login" className="text-[#DEFF9A] hover:underline">
              Iniciar sesión
            </Link>
          </p>

          <div className="text-center text-[10px] font-mono uppercase tracking-[0.22em] text-[#5A5F68] mt-10 leading-relaxed">
            ScanEye Labs <span className="text-[#DEFF9A]/60">|</span> Tecnología de Verificación Forense<br />por Antonio Moya Miralles
          </div>
        </div>
      </div>
    </div>
  );
}
